const businessTypeKey = 'businessType'
const defaultBusinessType = 'all'
export default () => {
    // http://localhost:3000/?hybridid=mob_ordercenter#orderlist.list?businessType=bus&filterBusiness=true&source=cardSmall
    try{
        const urlArr1 = window.location.href.split('?');
        const urlArr2 = urlArr1[urlArr1.length-1].split('&');
        const paramsObj: any = {};
        for(let i=0;i<urlArr2.length;i++){
            const keyValueArr = urlArr2[i].split('=');
            paramsObj[keyValueArr[0]] = keyValueArr[1]
        }
        return paramsObj[businessTypeKey] || defaultBusinessType;
    }catch(e){
        return defaultBusinessType
    }
}